import React, { useState } from "react";
import { Square } from "lucide-react";

const ImageThumbnail = ({ src, alt, className, onClick }) => {
  const [hasError, setHasError] = useState(false);
  
  if (!src || hasError) {
    return (
      <div className={`bg-slate-100 flex items-center justify-center ${className}`}>
        <Square className="w-4 h-4 text-slate-300" />
      </div>
    );
  }
  
  return (
    <div 
      className={`relative cursor-pointer group ${className}`}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-contain"
        onError={() => setHasError(true)}
      />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
        <span className="text-white opacity-0 group-hover:opacity-100 text-xs font-medium">
          Ver
        </span>
      </div>
    </div>
  );
};

export default ImageThumbnail;
